const choices = {
    fip: 'FIP',
    fcpi: 'FCPI',
    lodeom: 'LODEOM',
};

export default choices;
